// extracted by mini-css-extract-plugin
export var button = "_18-0";
export var buttonContent = "_18-e";
export var buttonGroup = "_18-c";
export var dontRestrainIconWidth = "_18-a";
export var dropdownButton = "_18-b";
export var iconContainer = "_18-9";
export var lg = "_18-4";
export var md = "_18-3";
export var pending = "_18-f";
export var sm = "_18-2";
export var spinner = "_18-d";
export var squared = "_18-8";
export var wrapText = "_18-g";
export var xl = "_18-5";
export var xs = "_18-1";
export var xxl = "_18-6";
export var xxxl = "_18-7";